import React from 'react'
import axios from 'axios'
import Exports from '../../../templates/Exports'
import queryString from 'query-string'
import { useParams } from 'react-router-dom'
import { useQuery } from 'react-query'
import useSearchParams from '../../../../hooks/useSearchParams'
import { getObjectFromUrlValues } from '../../../../utils/helpersAdmin'
import useUserPermission from '../../../../hooks/useUserPermission'

const fetchEnabledProcedureManagement = id =>
  axios.get(`/admin/v1/enabled_procedure_managements/${id}.json`).then(a => a.data)
const fetchExports = (search, exportableId) => {
  const parsedSearch = queryString.parse(search)

  const url = queryString.stringifyUrl({
    url: `/admin/v1/exports.json?exportable_id=${exportableId}&exportable_type=procedures`,
    query: parsedSearch
  })
  return axios.get(url).then(a => a.data)
}
const filterLabel = {
  search: 'Nombre o ID',
  area: 'Area',
  state: 'Estado',
  created_at_from: 'Ingresado desde',
  created_at_to: 'Ingresado hasta',
  expires_from: 'Vence desde',
  expires_to: 'Vence hasta'
}
const ProceduresExport = () => {
  const { id } = useParams()
  const { canManageProcedures, canSeeProcedures } = useUserPermission('procedureManagement')
  const { data: formData } = useQuery(['enabledProcedureManagement', id], () => fetchEnabledProcedureManagement(id))
  const urlParams = useSearchParams()
  const extractedParams = getObjectFromUrlValues(
    ['user_type_id', 'area_id', 'branch_office_id', 'access_id'],
    urlParams
  )

  const queryParams = {}
  if (canManageProcedures && extractedParams.access_id) {
    Object.assign(queryParams, {
      access_id: extractedParams.access_id,
      user_type_id: extractedParams.user_type_id,
      initial_load: true
    })
  }
  if (canSeeProcedures && extractedParams.user_type_id) {
    Object.assign(queryParams, {
      user_type_id: extractedParams.user_type_id,
      branch_office_id: extractedParams.branch_office_id,
      area_id: extractedParams.area_id
    })
  }
  const breadCrumbData = { queryParams }

  const exportDescription = `Estos son los archivos exportados para ${formData?.name}`
  return (
    <Exports
      generalData={{ ...formData, ...breadCrumbData }}
      fetchExports={fetchExports}
      exportDescription={exportDescription}
      exportableId={id}
      filterLabel={filterLabel}
      multipleExport
    />
  )
}

export default ProceduresExport
